import { Field, makeStyles, tokens } from '@fluentui/react-components';
import { ActionItemType, AddCommentToWorkItemActionType, AddCommentToWorkItemErrorsType } from '../types';
import { useMemo } from 'react';
import { useAutomationRuleActions } from '../use-actions';
import { TextAreaHelperText, TextAreaWithHighLights } from 'src/pages/automation-rule/work-item-variables';

interface Props {
	actionId: string;
	validations: AddCommentToWorkItemErrorsType | null;
}

export default function AddCommentToWorkItem(props: Props) {
	const classes = useStyles();
	const { actions, setActions, resetValidationErrors} = useAutomationRuleActions();

	const current = useMemo(() => {
		const found = actions.find(action => action.id === props.actionId) as ActionItemType;
		const addCommentToWI = found.addCommentToWorkItem;
		return addCommentToWI;
	}, [props.actionId, actions]);

	if (!current) {
		return null;
	}

	return (
		<>
			<Field
				className={classes.root}
				validationMessage={props.validations?.commentValue}
			>
				<TextAreaWithHighLights
					messageError={props.validations?.commentValue}
					placeholder='Add a comment'
					value={current.commentValue}
					onChange={(value) => {
						resetValidationErrors();
						setActions(oldActions => {
							const currentAction = oldActions.find(action => action.id === props.actionId) as ActionItemType; 
							const others = oldActions.filter(action => action.id !== props.actionId);

							return [
								...others,
								{
									...currentAction,
									addCommentToWorkItem: {
										...currentAction.addCommentToWorkItem as AddCommentToWorkItemActionType,
										commentValue: value,
									}
								}
							];
						});
					}}
				/>
			</Field>
			<TextAreaHelperText />
		</>
	);
}

export const useStyles = makeStyles({
	root: {
		width: '100%'
	},
	input: {
		width: '100%',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		outline: 'none',
		'::after': {
			borderBottom: 'none',
			height: 0,
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':focus-within': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1}`,
			borderBottomColor: `${tokens.colorNeutralStroke1}!important`,
			borderTopColor: `${tokens.colorNeutralStroke1}!important`,
			borderRightColor: `${tokens.colorNeutralStroke1}!important`,
			borderLeftColor: `${tokens.colorNeutralStroke1}!important`,
		},
	}
});